// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f75ac2fb","633":"9668f053"}[chunkId] + ".chunk.js";
};